/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D button
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";
import Spinner from "../GUI/Spinner";

function Button({
    disabled = false,
    text,
    type,
    width,
    height,
    textSize = "p1",
    textSizeDecimal,
    onClickHandler,
    textAlign = "center",
    aframeClasses,
    loading,
    ...otherAttributes
}) {
    let color, hoverColor, fontColor, d = disabled;

    switch (type) {
        case Button.constants.primary:
            color = d ? "#0d2c44" : "#0066B6"
            hoverColor = d ? color : "#14A1DE"
            fontColor = d ? "#D6D6D6" : "#E8E8E8"
            break;

        case Button.constants.success:
            color = d ? "#1CA35B" : "#15D36E"
            hoverColor = d ? color : "#27F186"
            fontColor = "#363636"
            break;

        case Button.constants.danger:
            color = d ? "#861E1E" : "#C10C0D"
            hoverColor = d ? color : "#E73131"
            fontColor = d ? "#D6D6D6" : "#E8E8E8"
            break;

        case Button.constants.dark:
            color = d ? "#272727" : "#3e3e3e"
            hoverColor = d ? color : "#505150"
            fontColor = d ? "#D6D6D6" : "#E8E8E8"
            break;

        default:
            color = d ? "#0d2c44" : "#0066B6"
            hoverColor = d ? color : "#14A1DE"
            fontColor = d ? "#D6D6D6" : "#E8E8E8"
            break;
    }

    return (
        <a-entity class="Button" {...otherAttributes}>
            <a-plane
                class={aframeClasses}
                width={width}
                height={height}
                color={color}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!disabled && !loading) onClickHandler(e);
                }}
                animation__mouseenter={`property: color; startEvents: mouseenter; to: ${hoverColor}; dur:150; enabled: ${!disabled}`}
                animation__mouseleave={`property: color; startEvents: mouseleave; to: ${color}; dur:150; enabled: ${!disabled}`}
            >
                {
                    loading ? <Spinner radius={0.025} position="0 0 0" /> :
                        <Text
                            position={`${textAlign === "left"
                                ? -width * 0.475
                                : textAlign === "right"
                                    ? width * 0.475
                                    : 0
                                } 0 ${height / 100}`}
                            color={fontColor}
                            align={textAlign}
                            size={textSize}
                            sizeDecimal={textSizeDecimal}
                            width={width * 0.95}
                            value={text}
                        />
                }
            </a-plane>
        </a-entity>
    );
}

Button.propTypes = {
    text: PropTypes.string.isRequired,
    width: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    height: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

Button.constants = {
    disabled: "disabled",
    primary: "primary",
    success: "success",
    danger: "danger",
    dark: "dark",
}

export default Button;
